<div id="logo" fxLayout="row">
    <img src="./../../assets/trakrCounting_colour.svg" fxFlex="60" fxFlex.md="35" fxFlex.lg="35" fxFlex.xl="35" class="mx-auto" style="margin-top: 8%; margin-bottom:30px"/>
</div>